import { render, staticRenderFns } from "./CargoPassengerType.vue?vue&type=template&id=0531ac5c&scoped=true&"
import script from "./CargoPassengerType.vue?vue&type=script&lang=js&"
export * from "./CargoPassengerType.vue?vue&type=script&lang=js&"
import style0 from "./CargoPassengerType.vue?vue&type=style&index=0&id=0531ac5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531ac5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0531ac5c')) {
      api.createRecord('0531ac5c', component.options)
    } else {
      api.reload('0531ac5c', component.options)
    }
    module.hot.accept("./CargoPassengerType.vue?vue&type=template&id=0531ac5c&scoped=true&", function () {
      api.rerender('0531ac5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/select/CargoPassengerType.vue"
export default component.exports